export default {
  TITLE: '兴趣导向的广告',
  CONTENT: `
      <p class="p-t-24">
          兴趣导向的广告有时被称为个性化的或有针对性的广告。我们显示兴趣导向的广告，以显示您可能感兴趣的功能、产品和服务。在提供兴趣导向的广告时，我们遵循由数字广告联盟（一个关于推广、在线广告和消费者维权的组织联盟）制定的《在线行为广告自律原则》。
      </p>
      <h3>我们用什么样的信息来展示兴趣导向的广告？</h3>
      <p>
          为了向您提供兴趣导向的广告，我们使用诸如您与亚马逊网站、内容或服务的互动等信息。我们不会使用您的身份信息来投放兴趣导向的广告，如姓名或电子邮件地址。
      </p>
      <p>
          如在广告行业中常见的行为，我们使用cookies、像素及其他技术（合称“cookies”），这使我们能够通过测量点击或观看的广告内容来了解我们向您展示的兴趣导向的广告的有效性，并为您提供更有用和相关的广告。例如，如果我们了解哪些广告已经显示给您的浏览器，我们将会谨慎，不会重复地显示相同的广告。
      </p>
      <p>
        有关我们收集的信息类型的更多信息，请参阅我们的<a data-path="termStatement" data-title="PRIVACY_STATEMENT">隐私声明</a>。
      </p>
      <h3>我们如何与第三方合作，向您展示兴趣导向的广告？</h3>
      <p>
          我们与第三方合作以提高我们所提供广告的相关性，如广告商、出版商、社交媒体网络、搜索引擎、广告服务公司以及代表他们工作的广告公司。在向您提供兴趣导向的广告时，我们不会将您在非关联网站上的交互与识别您的信息相关联，例如姓名或电子邮件地址，我们也不会向广告商或展示我们兴趣导向广告的第三方网站提供任何此类信息。广告商等第三方可以假定
      </p>
      <p>
          第三方广告商或代表他们工作的广告公司，有时使用
          cookies直接传递内容（包括广告）到您的浏览器或设备，当这种情况发生时，他们可能会自动收到一个
          IP地址。他们也可以用cookies来衡量他们广告的效果、向您展示更多相关的广告内容、并代表亚马逊提供服务。关于如何控制和删除cookies（包括第三方cookies）的信息，请访问我们的Cookies通知。
      </p>
      <h3>广告偏好</h3>
      <p>
          亚马逊为您提供接收兴趣导向广告的选择。您可以选择不接收来自亚马逊的兴趣导向广告。您仍然会看到广告，但它们不会基于您的兴趣。请访问您的<a data-path="adPreference">广告偏好</a>页面，了解如何设置您的偏好。
      </p>
      <p>
          有关其他亚马逊公司提供的网站和服务的广告宣传行为，请查看兴趣导向广告政策和其他通知。
      </p>
    `
};
